import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import NavBar from '../../../../_components/common/Navbar';
import Footer from '../../../../_components/common/Footer';
import SettingsHead from '../../../../_components/common/SettingsHead'
import TableNew from '../../../../_components/common/TableNew'

import { tables } from './CustomColumnTable'
import CustomTableNew from '../../../../_components/common/CustomTableNew'
import { CommonBreadCrumb } from '../../../../_components/common/CommonBreadCrumb'
import { manageBatchActions } from '../../../../_actions/organisations/manageBatchList.action'
import ModalNew2 from '../../../../_components/common/ModalNew2'
import Page404 from '../../../404page';



import { addBatch, reportThemeData, allotBatchFormData, setDevPlan } from '../formData';

import Swal from 'sweetalert2'
import { organisationAction } from '../../../../_actions/organisation.action';


import { compareBy } from '../component/CompareFunc';
import { toast } from 'react-toastify';

import '../../../../_components/common/Form2/index.css';

import { developmentPlanActions } from '../../../../_actions';
import { LoaderComp } from '../../../../_components/common/LoaderComp/Loadercomp';

var moment = require('moment');

class CustomTag extends Component {
    state = {

        sellerId: 0,
        orgId: 0,
        locationId: 0,

        editOrgModal: false,
        addBatchModal: false,
        modal: false,
        addOrgState: false,
        showHeading: false,
        currentModalId: 11,
        showModalView: true,

        selectedBoxData: 1,
        buttonUnallottedData: [],
        buttonParticipentData: [],
        addParticipentsModal: false,
        allotAssessmentModal: false,
        enablePiModal: false,
        disablePiModal: false,
        participantData: '',
        allotBatchesModal: false,
        setExpiryDateModal: false,
        unsubmitAssessmentModal: false,
        resetAssessmentModal: false,

        deleteReportModal: false,
        setReportThemeModal: false,
        setDevelopmentPlanModal: false,
        buttonBatchData: [],
        checkBoxData: [],
        getImpId: false,
        setCustomReportAccess: false,
        itemObj: [],
        tableModal: false,
        topTextModal: '',
        bottomTextModal: '',
        removeCustomReportAccess: false,
        sortTypeBatch: false,
        organisationBatchTable: '',
        sortTypeUnallot: false,
        organisationUnallotTable: '',
        removeIndividualAnalytics: false,
        addIndividualAnalytics: false,
        deleteReportText: '',
        breadCrumbData: [],
        submittedAssessment: {
            status: false,
            stringArr: ''
        },

        setCustomReportData: [],
        vviSelected: false,
        expiryValue: '',
        expiryPlaceholderValidator: [],


        hasProperOrgId: true,
        idLoader: true,
    }

    componentDidMount() {
        const { dispatch, } = this.props;

        tables.UnallotedAssesments.map(val => {
            val['modalOpener'] = (data) => this.modalOpener(data)
        })

        let sellerIdLocal = localStorage.getItem('seller_id')
        let orgIdLocal = localStorage.getItem('orgId')
        let userType = localStorage.getItem('usertype')



        //get organisation
        dispatch(organisationAction.getOrganisation((callbackData) => {
            this.getSellerOrgId()
        }))


        if (userType.includes('super_admin')) {
            //GetThemeReport
            dispatch(manageBatchActions.getThemeReportAction())


            //dev plan data
            dispatch(developmentPlanActions.getDevelopmentPlan())

        }

        //Get Custom Report Data
        dispatch(manageBatchActions.getCustomReportAction())



        let orgIdFromPath = this.props.location.pathname.match(/\d/g);
        orgIdFromPath = orgIdFromPath.join("");
        this.setState({
            locationId: orgIdFromPath
        }, () => {
            if (sellerIdLocal !== 'null' && !userType.includes('super_admin')) {
                this.setState({
                    breadCrumbData: [
                        {
                            link: '/admin/app/dashboard',
                            name: 'ADMIN'
                        }, {
                            link: '/admin/app/organisation',
                            name: 'ORGANISATION'
                        }, {
                            link: `/admin/app/organisation/${this.state.locationId}`,
                            name: 'ORGANISATION DETAILS'
                        }, {
                            link: '',
                            name: 'MANAGE BATCHES'
                        }
                    ],
                    buttonUnallottedData: [
                        {
                            id: 1,
                            heading: "ALLOT BATCH",
                            state: this.state.allotAssessmentModal,
                            toggler: this.allotAssessmentToggle.bind(this),
                            disabled: "disabled",
                            // doNotDisable: true
                        },
                        {
                            id: 2,
                            heading: "CHANGE EXPIRY DATE",
                            state: this.state.setReportThemeModal,
                            toggler: this.setExpiryDateToggle.bind(this),
                            disabled: "disabled",
                            // doNotDisable: true

                        },
                        {
                            id: 4,
                            heading: "TOGGLE REPORT",
                            state: this.state.toggleReportModal,
                            toggler: this.toggleReportToggle.bind(this),
                            disabled: "disabled",
                        },
                        {
                            id: 6,
                            heading: "DELETE ASSESSMENT",
                            state: this.state.deleteReportModal,
                            toggler: this.deleteReportToggle.bind(this),
                            disabled: "disabled",
                            // doNotDisable: true
                        }
                    ]
                }, () => {
                    if (orgIdLocal !== 'null') {
                        this.setState({
                            breadCrumbData: [
                                {
                                    link: '/admin/app/dashboard',
                                    name: 'ADMIN'
                                }, {
                                    link: '',
                                    name: 'MANAGE BATCHES'
                                }
                            ],
                            buttonUnallottedData: [
                                {
                                    id: 1,
                                    heading: "ALLOT BATCH",
                                    state: this.state.allotAssessmentModal,
                                    toggler: this.allotAssessmentToggle.bind(this),
                                    disabled: "disabled",
                                    // doNotDisable: true
                                },
                                {
                                    id: 6,
                                    heading: "DELETE ASSESSMENT",
                                    state: this.state.deleteReportModal,
                                    toggler: this.deleteReportToggle.bind(this),
                                    disabled: "disabled",
                                    // doNotDisable: true
                                }
                            ]
                        })
                    }
                })
            } else {
                this.setState({
                    breadCrumbData: [
                        {
                            link: '/admin/app/dashboard',
                            name: 'ADMIN'
                        }, {
                            link: '/admin/app/organisation',
                            name: 'ORGANISATION'
                        }, {
                            link: `/admin/app/organisation/${this.state.locationId}`,
                            name: 'ORGANISATION DETAILS'
                        }, {
                            link: '',
                            name: 'MANAGE BATCHES'
                        }
                    ],
                    buttonUnallottedData: [
                        {
                            id: 1,
                            heading: "ALLOT BATCH",
                            state: this.state.allotAssessmentModal,
                            toggler: this.allotAssessmentToggle.bind(this),
                            disabled: "disabled",
                            // doNotDisable: true
                        },
                        {
                            id: 2,
                            heading: "CHANGE EXPIRY DATE",
                            state: this.state.setReportThemeModal,
                            toggler: this.setExpiryDateToggle.bind(this),
                            disabled: "disabled",
                            // doNotDisable: true

                        },
                        {
                            id: 3,
                            heading: "UNSUBMIT ASSESSMENT",
                            state: this.state.unsubmitAssessmentModal,
                            toggler: this.unsubmitAssessmentToggle.bind(this),
                            // doNotDisable: true,
                            disabled: "disabled"
                        },
                        {
                            id: 4,
                            heading: "TOGGLE REPORT",
                            state: this.state.toggleReportModal,
                            toggler: this.toggleReportToggle.bind(this),
                            disabled: "disabled",
                        },



                        {
                            id: 6,
                            heading: "DELETE ASSESSMENT",
                            state: this.state.deleteReportModal,
                            toggler: this.deleteReportToggle.bind(this),
                            disabled: "disabled",
                            // doNotDisable: true
                        },
                        // {
                        //     id: 7,
                        //     heading: "SET REPORT THEME",
                        //     state: this.state.setReportThemeModal,
                        //     toggler: this.setReportThemeToggle.bind(this),
                        //     disabled: "disabled",

                        // },
                        {
                            id: 8,
                            heading: "DEVELOPMENT PLAN",
                            state: this.state.setDevelopmentPlanModal,
                            toggler: this.setDevelopmentPlanToggle.bind(this),
                            disabled: "disabled"
                        },
                        {
                            id: 9,
                            heading: "SET CUSTOM REPORT ACCESS",
                            state: false,
                            toggler: this.setCustomReportToggle.bind(this),
                            disabled: "disabled"
                        },
                        {
                            id: 10,
                            heading: "REMOVE CUSTOME REPORT ACCESS",
                            state: false,
                            toggler: this.removeCustomReportToggle.bind(this),
                            disabled: "disabled"
                        },
                        {
                            id: 11,
                            heading: "BULK UPLOAD",
                            state: false,
                            toggler: this.handleBulkUpload.bind(this),
                            doNotDisable: true
                        },
                        {
                            id: 13, // Use a unique ID
                            heading: "RESET ASSESSMENT",
                            state: this.state.resetAssessmentModal,
                            toggler: this.resetAssessmentToggle.bind(this),
                            disabled: "disabled"
                        }



                        // {
                        //     id: 11,
                        //     heading: "Add Individual Analytics",
                        //     state: false,
                        //     toggler: this.addIndividualAnalyticsToggle.bind(this),
                        //     disabled: "disabled"
                        // },
                        // {
                        //     id: 12,
                        //     heading: "Remove Individual Analytics",
                        //     state: false,
                        //     toggler: this.removeIndividualAnalyticsToggle.bind(this),
                        //     disabled: "disabled"
                        // }
                    ]
                })
            }
        })

    }

    addIndividualAnalyticsToggle(data) {
        this.setState({
            addIndividualAnalytics: data
        })
    }

    removeIndividualAnalyticsToggle(data) {
        this.setState({
            removeIndividualAnalytics: data
        })
    }

    //Mangae Batches

    filterData = (data) => {
        this.setState({
            participantData: data
        });
    }

    toggleModal(showModal) {
        this.setState({
            modal: showModal
        });
    }

    currentModal(data) {
        this.setState({
            currentModalId: data,
            showModalView: !this.state.showModalView
        })
    }



    selectAllBatch(data, clickToggle) {
        const { buttonUnallottedData } = this.state;

        if (clickToggle === true) {
            // Check if any selected assessment is LOI-Self or VVI
            const hasDisabledInstruments = data.some(item =>
                item.instrument__instrument_name === "LOI-Self" ||
                item.instrument__instrument_name === "VVI"
            );

            buttonUnallottedData.map(val => {
                if (val.disabled !== undefined) {
                    // Special handling for unsubmit button (id: 3)
                    if (val.id === 3) {
                        val.disabled = hasDisabledInstruments ? 'disabled' : '';
                    } else {
                        val.disabled = '';
                    }
                }
                return val;
            });

            this.setState({
                reRenderSettingsHead: 2,
                paticipantListData: data
            });
        } else {
            buttonUnallottedData.map(val => {
                if (val.disabled !== undefined) {
                    val.disabled = 'disabled';
                }
                return val;
            });

            this.setState({
                reRenderSettingsHead: 1,
                paticipantListData: data
            });
        }
    }

    getSelectedData(data) {
        if (data.length !== 0) {
            // Check if any selected assessment is LOI-Self or VVI
            const hasDisabledInstruments = data.some(item =>
                item.instrument__instrument_name === "LOI-Self" ||
                item.instrument__instrument_name === "VVI"
            );

            // Update buttonUnallottedData to set unsubmit button state
            const updatedButtonData = this.state.buttonUnallottedData.map(button => {
                if (button.id === 3) { // ID 3 is for UNSUBMIT ASSESSMENT button
                    return {
                        ...button,
                        disabled: hasDisabledInstruments ? 'disabled' : ''
                    };
                }
                return button;
            });

            this.setState({
                checkBoxData: data,
                buttonUnallottedData: updatedButtonData,
                reportAction: null,
                affectedReportCount: 0
            }, () => {
                this.selectAllBatch(this.state.checkBoxData, true)
            });
        } else if (data.length === 0) {
            // Reset button states when no checkboxes are selected
            const updatedButtonData = this.state.buttonUnallottedData.map(button => {
                if (button.disabled !== undefined) {
                    return {
                        ...button,
                        disabled: 'disabled'
                    };
                }
                return button;
            });

            this.setState({
                checkBoxData: data,
                buttonUnallottedData: updatedButtonData,
                reportAction: null,
                affectedReportCount: 0
            }, () => {
                this.selectAllBatch(this.state.checkBoxData, false)
            });
        }
    }


    onAddBatch(data) {
        const { dispatch } = this.props
        // parseInt(data.organisation_mandate_group, 10)
        // data.organisation_mandate_group = null
        let constructData = Object.assign({}, data)

        if (constructData.organisation_mandate_group === '') {
            constructData.min_respondent = parseInt(constructData.min_respondent, 10)
            constructData.organisation_mandate_group = null
        }
        // Handle the orientation field
        if (constructData.orientations && constructData.orientations.length > 0) {
            constructData.orientations = constructData.orientations // This line isn't strictly necessary, but kept for clarity
        } else {
            constructData.orientations = []
        }


        dispatch(manageBatchActions.addBatchAction({
            sellerId: this.props.getOrgSellerId.sellerId,
            orgId: this.props.getOrgSellerId.orgId,
            data: constructData
        }))

    }

    delAdmin(key, data) {
        const { dispatch } = this.props;

        Swal({
            title: 'Are you sure you want to delete this Batch?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it'
        }).then((result) => {
            if (result.value) {
                dispatch(manageBatchActions.deleteBatchAction({
                    sellerId: this.props.getOrgSellerId.sellerId,
                    orgId: this.props.getOrgSellerId.orgId,
                    data: {
                        batch_id: data.id
                    }
                }))
                let toastId = toast['info']('Deleted Batch Successfully!', {
                    position: toast.POSITION.BOTTOM_LEFT,
                    autoClose: 1500,
                });

                toast.update(toastId, {
                    render: `Deleted ${data.batch_name} Batch Successfully!`,
                    type: toast.TYPE.INFO,
                    className: 'styleToastSuccess'
                })
            }
        })

    }

    setDevelopmentPlanToggle(data) {
        let checkBoxData = [...this.state.checkBoxData]

        let vviSelected = false

        checkBoxData.map(val => {
            if (!val.instrument__is_custom_report_enabled && !val.instrument__is_development_plan_enabled) {
                vviSelected = true
            }
        })
        this.setState({
            vviSelected,
            setDevelopmentPlanModal: data
        })
    }

    toggleEntireModal(showModal) {
        this.setState({
            setDevelopmentPlanModal: showModal,
        })
    }

    setDevelopmentPlanAction(data) {
        const { dispatch } = this.props;
        let checkBoxId = [];
        this.state.checkBoxData.map(val => {
            checkBoxId.push(val.id)
        })



        dispatch(manageBatchActions.setDevelopmentAction({
            data: {
                user_assessment_id: checkBoxId,
                dev_plan: data.dev_plan === '1' ? true : false
            },
            getAllot: {
                data: {
                    batch_id: null,
                    organisation_id: this.state.orgId
                }
            }
        }))
    }

    toggleAddBatch(data) {
        this.setState({
            addBatchModal: data
        })
    }

    allotAssessmentToggle(data) {
        this.setState({
            allotAssessmentModal: data
        })
    }
    resetAssessmentToggle(data) {
        this.setState({
            resetAssessmentModal: data
        });
    }


    unsubmitAssessmentToggle(data) {
        this.setState({
            unsubmitAssessmentModal: data
        })
    }

    deleteReportToggle(data) {
        this.setState({
            deleteReportModal: data,
            deleteReportText: 'Are you sure you want to delete these assessments?'
        })
    }
    toggleReportToggle(data) {
        const enabledCount = this.state.checkBoxData.filter(item => item.enable_report).length;
        const disabledCount = this.state.checkBoxData.length - enabledCount;

        let action, affectedCount;
        if (enabledCount >= disabledCount) {
            action = 'disable';
            affectedCount = enabledCount;
        } else {
            action = 'enable';
            affectedCount = disabledCount;
        }

        this.setState({
            toggleReportModal: data,
            reportAction: action,
            affectedReportCount: affectedCount
        });
    }

    toggleReport(data) {
        const { dispatch } = this.props;
        if (this.state.checkBoxData.length !== 0) {
            let dataEmail = this.state.checkBoxData.map(val => val.id);
            const action = this.state.reportAction === 'enable' ?
                manageBatchActions.enableReportsAction :
                manageBatchActions.disableReportsAction;

            dispatch(action({
                orgId: this.props.getOrgSellerId.orgId,
                batchId: null,
                data: {
                    users_assessment_id: dataEmail
                }
            }));
        }
    }






    setExpiryDateToggle(data) {
        const { allotedUnallotedList } = this.props;
        let arrayEmailsSubmitted = []
        this.state.checkBoxData.map(value => {
            allotedUnallotedList.map(val => {
                if (val.id === value.id) {
                    if (value.is_submited) {
                        arrayEmailsSubmitted.push(value.participant__email)
                    }
                }
            })
        })

        let submittedErrorObject = {
            status: arrayEmailsSubmitted.length !== 0 ? true : false,
            stringArr: arrayEmailsSubmitted
        }

        let expiryValue = ''

        if (this.state.checkBoxData.length === 1) {
            expiryValue = this.state.checkBoxData[0].expiry_date
        } else {
            expiryValue = moment().format('YYYY-MM-DD')
        }



        this.setState({
            submittedAssessment: { ...submittedErrorObject },
            setExpiryDateModal: data,
            expiryValue
        }, () => {

        })
    }

    setReportThemeToggle(data) {
        this.setState({
            setReportThemeModal: data
        })
    }

    setCustomReportToggle(data) {

        let checkBoxData = [...this.state.checkBoxData]
        let setCustomReportData = []
        let counter = 0
        let vviSelected = false

        checkBoxData.map(val => {
            if (!val.default_report) {
                counter++
            }
            if (!val.instrument__is_custom_report_enabled && !val.instrument__is_development_plan_enabled) {
                vviSelected = true
            }
        })



        if (!vviSelected) {
            if (checkBoxData.length === 1) {
                checkBoxData.map(val => {

                    setCustomReportData = [...val.report_list]
                })
            } else if (counter === 0) {

                checkBoxData.map(val => {

                    setCustomReportData = [...val.report_list]
                })
            }
        }


        this.setState({
            vviSelected,
            setCustomReportData,
            setCustomReportAccess: data
        })
    }
    removeCustomReportToggle(data) {
        let checkBoxData = [...this.state.checkBoxData]

        let vviSelected = false

        checkBoxData.map(val => {
            if (!val.instrument__is_custom_report_enabled && !val.instrument__is_development_plan_enabled) {
                vviSelected = true
            }
        })
        this.setState({
            vviSelected,
            removeCustomReportAccess: data
        })
    }

    handleBulkUpload() {
        const { orgId } = this.state;
        this.props.history.push(`/admin/app/organisation/${orgId}/uploadAssessment`);
    }



    //Action

    allotAssessment(data) {
        const { dispatch } = this.props
        if (this.state.checkBoxData.length !== 0) {
            let dataEmail = []
            this.state.checkBoxData.map(val => {
                dataEmail.push(val.id)
            })
            dispatch(manageBatchActions.allotBatchesAction({
                sellerId: this.props.getOrgSellerId.sellerId,
                orgId: this.props.getOrgSellerId.orgId,
                batchId: data.organisation_batch_list,
                data: {
                    user_assessment_id: dataEmail
                }
            }))
        }

    }

    setExpiryDate(data) {

        const { dispatch } = this.props

        var date = data.expiry_list;

        var newdate = date.split("/").reverse().join("-");

        if (this.state.checkBoxData.length !== 0) {
            let dataEmail = []
            this.state.checkBoxData.map(val => {
                dataEmail.push(val.id)
            })
            dispatch(manageBatchActions.setExpiryDateAction({
                orgId: this.props.getOrgSellerId.orgId,
                batchId: null,
                data: {
                    users_assessment_id: dataEmail,
                    expiry_date: newdate
                }
            }))
        }
    }

    handleExpiryPlaceholder = (data) => {
        if (data == '') {
            return ''
        }
        else {
            if (data.length > 1) {
                return moment()
            }
            else {
                const endDate = moment(data[0].expiry_date, 'YYYY-MM-DD').format('DD-MM-YYYY')
                let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
                let dateArr = endDate.split('-')
                let dicreement = dateArr[1] - 1
                let changedDate = months[dicreement]
                dateArr[1] = changedDate
                let properDate = dateArr.join('-')
                return properDate;
            }
        }
    }

    enableReport(data) {
        const { dispatch } = this.props
        if (this.state.checkBoxData.length !== 0) {
            let dataEmail = []
            this.state.checkBoxData.map(val => {
                dataEmail.push(val.id)
            })
            dispatch(manageBatchActions.enableReportsAction({
                orgId: this.props.getOrgSellerId.orgId,
                batchId: null,
                data: {
                    users_assessment_id: dataEmail
                }
            }))
        }
    }

    disableReport(data) {
        const { dispatch } = this.props
        if (this.state.checkBoxData.length !== 0) {
            let dataEmail = []
            this.state.checkBoxData.map(val => {
                dataEmail.push(val.id)
            })
            dispatch(manageBatchActions.disableReportsAction({
                orgId: this.props.getOrgSellerId.orgId,
                batchId: null,
                data: {
                    users_assessment_id: dataEmail
                }
            }))
        }
    }

    deleteReport(data) {
        const { dispatch } = this.props
        if (this.state.deleteReportText !== '') {
            if (this.state.checkBoxData.length !== 0) {
                let checkboxIdArr = []
                this.state.checkBoxData.map(val => {
                    checkboxIdArr.push(val.id)
                })
                dispatch(manageBatchActions.deleteReportsAction({
                    orgId: this.props.getOrgSellerId.orgId,
                    batchId: null,
                    data: {
                        users_assessment_id: checkboxIdArr
                    }
                }))
                this.setState({
                    deleteReportText: ''
                })
            }
        }
    }

    unsubmitAssessment(data) {
        const { dispatch } = this.props
        if (this.state.checkBoxData.length !== 0) {
            let dataEmail = []
            this.state.checkBoxData.map(val => {
                dataEmail.push(val.id)
            })
            dispatch(manageBatchActions.unsubmittedAssessmentAction({
                orgId: this.props.getOrgSellerId.orgId,
                batchId: null,
                data: {
                    users_assessment_id: dataEmail
                }
            }))
        }
    }

    setReportTheme(data) {
        const { dispatch } = this.props

        if (this.state.checkBoxData.length !== 0) {
            let dataEmail = []
            this.state.checkBoxData.map(val => {
                dataEmail.push(val.id)
            })
            dispatch(manageBatchActions.setReportThemeAction({
                orgId: this.props.getOrgSellerId.orgId,
                batchId: null,
                data: {
                    participants: dataEmail,
                    theme_id: data.theme_list
                }
            }))
        }
    }




    getSellerOrgId() {
        const { dispatch } = this.props;
        const { locationId } = this.state;
        const { orgList } = this.props;

        let organisationId = parseInt(locationId, 10)



        orgList !== '' &&
            this.mapOrgList({
                orgList,
                locationId: organisationId,
                dispatch
            })

    }

    mapOrgList(objectData) {
        const { orgList, locationId, dispatch } = objectData

        let hasId = false;

        orgList.map(val => {
            if (locationId == val.id) {
                hasId = true
                return this.setStateForIds({
                    val,
                    dispatch,
                    locationId
                })
            }
        })

        this.setState({
            hasProperOrgId: hasId,
            idLoader: false
        })

    }

    setStateForIds(objectData) {
        const { locationId, val, dispatch } = objectData;
        return this.setState({
            orgId: locationId,
            sellerId: val.seller__id,
            getImpId: true,
        }, () => {
            const { orgId, sellerId } = this.state;

            //get batches
            dispatch(manageBatchActions.getBatchList({
                orgId,
                sellerId,
            }));

            //Mandate_org
            dispatch(manageBatchActions.addOrgMandate({
                sellerId,
                orgId
            }))

            //AllotUnallot
            dispatch(manageBatchActions.getAllotedUnallotedListAction({
                data: {
                    batch_id: null,
                    organisation_id: orgId
                }
            }))
            dispatch(organisationAction.setIds({
                orgId,
                sellerId
            }))
        })
    }


    setCustomReportAction(data) {
        const { dispatch } = this.props;
        let selectedUserId = [];
        let dataName = []
        data.map(val => {
            dataName.push({
                id: val.id,
                relation_group_name: val.name
            })
        })
        this.state.checkBoxData.map(value => {
            selectedUserId.push(value.id)
        })
        let postData = {
            get: {
                data: {
                    batch_id: null,
                    organisation_id: this.state.orgId
                }
            },
            data: {
                users_assessment_id: selectedUserId,
                custom_access: 0,
                assessment_report_list: dataName
            }
        }
        dispatch(manageBatchActions.setReportCustom(postData))
    }

    resetAssessmentAction() {
        const { dispatch } = this.props;
        if (this.state.checkBoxData.length !== 0) {
            let dataEmail = []
            this.state.checkBoxData.map(val => {
                dataEmail.push({
                    assessment_id: val.id,
                    organisation_id: this.state.orgId,
                    batch_id: null
                })
            });

            // Counter to track completed requests
            let completedRequests = 0;
            let successCount = 0;
            let errorMessages = [];

            dataEmail.forEach(data => {
                dispatch(manageBatchActions.resetAssessmentAction(data))
                    .then(result => {
                        completedRequests++;
                        if (result.success) {
                            successCount++;
                        } else {
                            errorMessages.push(result.message);
                        }

                        // When all requests are complete
                        if (completedRequests === dataEmail.length) {
                            // Close the modal first
                            this.setState({ resetAssessmentModal: false }, () => {
                                // Then show the appropriate message
                                if (successCount === dataEmail.length) {
                                    // All successful
                                    Swal({
                                        title: "Success",
                                        text: result.message,
                                        icon: "success"
                                    });
                                } else if (successCount === 0) {
                                    // All failed
                                    Swal({
                                        title: "Error",
                                        text: errorMessages.join('\n'),
                                        icon: "error"
                                    });
                                } else {
                                    // Mixed results
                                    Swal({
                                        title: "Partial Success",
                                        text: `Successfully reset ${successCount} out of ${dataEmail.length} assessments.`,
                                        icon: "warning"
                                    });
                                }
                            });
                        }
                    });
            });
        }
    }



    removeCustomReportAction(data) {
        const { dispatch } = this.props;
        let selectedUserId = [];
        let dataName = []
        data.map(val => {
            dataName.push({
                id: val.id,
                relation_group_name: val.name
            })
        })
        this.state.checkBoxData.map(value => {
            selectedUserId.push(value.id)
        })
        let postData = {
            get: {
                data: {
                    batch_id: null,
                    organisation_id: this.state.orgId
                }
            },
            data: {
                users_assessment_id: selectedUserId,
                custom_access: 1,
                assessment_report_list: dataName
            }
        }
        dispatch(manageBatchActions.setReportCustom(postData))
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.allotedUnallotedList !== this.props.allotedUnallotedList) {
            if (this.props.allotedUnallotedList !== '') {

            }
        }
    }

    modalOpener(data) {
        let stringAttach = '';
        let stringUnattach = '';
        let stringRemaining = [];
        let remaining = [...this.props.getCustomData.results]
        if (data !== false) {
            data.report_list.map(val => {
                if (stringAttach === '') {
                    stringAttach = stringAttach + val.relation_group_name
                } else if (stringAttach !== '') {
                    stringAttach = stringAttach + ', ' + val.relation_group_name
                }
                stringRemaining.push(val)
                remaining.map((value, key) => {
                    if (val.relation_group_id === value.id) {
                        remaining.splice(key, 1)
                    }
                })
            })

            remaining.map(val => {
                if (stringUnattach === '') {
                    stringUnattach = stringUnattach + val.relation_group_name
                } else if (stringUnattach !== '') {
                    stringUnattach = stringUnattach + ', ' + val.relation_group_name
                }
            })

        }



        this.setState({
            tableModal: data,
            topTextModal: stringAttach,
            bottomTextModal: stringUnattach
        })
    }

    sortBy(columnKey, type, tableName) {

        if (tableName === 'organisationBatchTable') {
            this.setState({ sortTypeBatch: type })
            const arrayCopy = this.state.organisationBatchTable === '' ? this.props.batchList : this.state.organisationBatchTable;
            arrayCopy.sort(compareBy(columnKey, this.state.sortTypeBatch));
            this.setState({ organisationBatchTable: arrayCopy })
        }

        if (tableName === 'organisationUnallotTable') {
            this.setState({ sortTypeUnallot: type })
            const arrayCopy2 = this.state.organisationUnallotTable === '' ? this.props.allotedUnallotedList : this.state.organisationUnallotTable;
            arrayCopy2.sort(compareBy(columnKey, this.state.sortTypeUnallot));
            this.setState({ organisationUnallotTable: arrayCopy2 })
        }

    }

    addIndividualAnalyticsAction = (data) => {
        const { dispatch } = this.props;
        let dataObj = {
            users_id: []
        }
        this.state.checkBoxData.map(val => {
            dataObj.users_id.push(val.id)
        })
        dispatch(manageBatchActions.addAnalyticsAction({
            data: dataObj,
            get: {
                data: {
                    batch_id: null,
                    organisation_id: this.state.orgId
                }
            }
        }))

    }

    removeIndividualAnalyticsAction = (data) => {
        const { dispatch } = this.props;
        let dataObj = {
            users_id: []
        }
        this.state.checkBoxData.map(val => {
            dataObj.users_id.push(val.participant__id)
        })
        dispatch(manageBatchActions.removeAnalyticsAction({
            data: dataObj,
            get: {
                data: {
                    batch_id: null,
                    organisation_id: this.state.orgId
                }
            }
        }))

    }

    expiryCallback(data) {
        this.setState({ expiryPlaceholderValidator: data })
    }

    renderManageOrganization() {

        const that = this;

        const { alloted_unalloted_list_loading, alloted_unalloted_list_error, allotedUnallotedList, addOrgMandate, getThemeRep, batchList, batch_list_error, batch_list_loading, orgError, orgLoading, orgList, dispatch, developmentPlanResponse, developmentPlanLoading } = this.props;

        const usertype = localStorage.getItem('usertype');
        const is_primary_admin = localStorage.getItem('is_primary_admin');


        const toggleReportButton = this.state.buttonUnallottedData.find(btn => btn.id === 4);
        if (toggleReportButton) {
            const allEnabled = this.state.checkBoxData.every(item => item.enable_report);
            const allDisabled = this.state.checkBoxData.every(item => !item.enable_report);
            toggleReportButton.heading = allEnabled ? "DISABLE REPORT" : allDisabled ? "ENABLE REPORT" : "TOGGLE REPORT";
        }




        tables.ManageBatches.map((a, b) => {
            if (a.linkActive === true) {
                a.link = this.props.location.pathname + '/'
            }
        })

        const buttonDataProp = [
            {
                id: 11,
                heading: "Add a new Batch",
                state: this.state.addBatchModal,
                toggler: this.toggleAddBatch.bind(this),
            }
        ]

        addBatch.map(function (element) {
            //place select data to element config options

            if (element.key === 'organisation_mandate_group') {
                element.elementConfig.options = addOrgMandate;
            }
        });

        reportThemeData.map(function (element) {
            //place select data to element config options
            if (element.key === 'theme_list') {
                element.elementConfig.options = getThemeRep;
            }
        });

        allotBatchFormData.map(function (element) {
            //place select data to element config options
            if (element.key === 'organisation_batch_list') {
                element.elementConfig.options = batchList;
            }
        });

        allotedUnallotedList !== '' &&
            allotedUnallotedList.map(val => {
                if (val.dev_plan === 0) {
                    val.dev_plan = 'Integrated'
                } else if (val.dev_plan === 1) {
                    val.dev_plan = 'Stand-alone'
                }
                val["idString"] = `${val.id}`
            })





        return (
            <div className="container custom-container my-5" >

                <div style={{ marginBottom: 30 }}>
                    <CommonBreadCrumb
                        data={this.state.breadCrumbData}
                    />
                    <div className="bg-green rounded-top animation-fade-in">
                        {
                            (!batch_list_error && !batch_list_loading) ?
                                <p className="h6 text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular animation-fade-in"> BATCHES </p>
                                :
                                <div className="text-right d-flex" style={{ justifyContent: 'space-between' }}>
                                    <p></p>
                                    <p className="h6 text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular animation-fade-in"> BATCHES </p>
                                    <LoaderComp color={'white'} />
                                </div>
                        }
                    </div>
                    {
                        (!batch_list_error && !batch_list_loading) &&
                        ((usertype.includes('organisation_admin') && is_primary_admin === 'true') || (!usertype.includes('organisation_admin'))) &&
                        <div className="animation-fade-in">
                            <SettingsHead
                                disableState={this.state.disableButtonState}
                                buttonData={
                                    buttonDataProp
                                }
                                secondColumn={false}
                                modal={this.toggleModal.bind(this)}
                                deleteAction={''}
                                widthClass="col-md-12"
                            />
                        </div>
                    }

                    <TableNew
                        data={this.props.batchList}
                        columns={tables.ManageBatches}
                        showSlNo="false"
                        revokeCreditsModal={this.delAdmin.bind(this)}
                        sellerState={this.props.location.state}
                        sortBy={(key) => this.sortBy(key, !this.state.sortTypeBatch, 'organisationBatchTable')}
                        sortType={this.state.sortTypeBatch}
                    />
                </div>

                <div style={{ marginBottom: 30 }}>
                    <div className="bg-green rounded-top">
                        {
                            (!alloted_unalloted_list_error && !alloted_unalloted_list_loading) ?
                                <p className="h6 text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular"> UNALLOTED ASSESSMENTS </p>
                                :
                                <div className="text-right d-flex" style={{ justifyContent: 'space-between' }}>
                                    <p></p>
                                    <p className="h6 text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular"> UNALLOTED ASSESSMENTS </p>
                                    <LoaderComp color={'white'} />
                                </div>
                        }
                    </div>
                    {
                        (!alloted_unalloted_list_error && !alloted_unalloted_list_loading) &&
                        <div className="animation-fade-in">
                            <SettingsHead
                                buttonData={this.state.buttonUnallottedData}
                                secondColumn={false}
                                modal={this.toggleModal.bind(this)}
                                deleteAction={''}
                                widthClass="col-md-12"
                            />
                        </div>
                    }

                    <CustomTableNew
                        data={this.props.allotedUnallotedList}
                        columns={localStorage.getItem('usertype').split(',').includes('seller_admin') ? tables.UnallotedAssesments_seller_admin : localStorage.getItem('usertype').split(',').includes('organisation_admin') ? tables.UnallotedAssesments_org_admin : tables.UnallotedAssesments}
                        checkboxData={this.state.checkBoxData}
                        showSlNo="false"
                        checkbox="true"
                        selectCheckBox={this.selectAllBatch.bind(this)}
                        getData={this.getSelectedData.bind(this)}
                        format={[{
                            format: 'icon',
                            key: 'is_submited'
                        }]}
                        CheckKey={'idString'}
                        modalOpener={this.modalOpener.bind(this)}
                        sortBy={(key) => this.sortBy(key, !this.state.sortTypeUnallot, 'organisationUnallotTable')}
                        sortType={this.state.sortTypeUnallot}
                        handleExpiryCallBack={this.expiryCallback.bind(this)}
                    />

                    {
                        this.state.addBatchModal &&
                        <ModalNew2
                            heading="ADD NEW BATCH"
                            showModal={this.state.addBatchModal}
                            formData={addBatch}
                            selects={['assessor_group__assessor_name', 'orientations']}
                            action={this.onAddBatch.bind(this)}
                            toggleModal={this.toggleAddBatch.bind(this)}
                            viewMessage={[{ text: '' }]}
                            triggerType={"SUBMIT"}
                            noReset={'noReset'}
                            selectKey={['id']}
                        />
                    }

                    {
                        this.state.allotAssessmentModal &&
                        <ModalNew2
                            heading="ALLOT BATCH"
                            showModal={this.state.allotAssessmentModal}
                            formData={allotBatchFormData}
                            selects={['batch_name']}
                            action={this.allotAssessment.bind(this)}
                            toggleModal={this.allotAssessmentToggle.bind(this)}
                            viewMessage={[{ text: `You have selected ${this.state.checkBoxData.length} assessment.` }]}
                            triggerType={"SUBMIT"}
                            noReset={'noReset'}
                            selectKey={['id']}
                        />
                    }
                    {
                        this.state.unsubmitAssessmentModal &&
                        <ModalNew2
                            heading="UNSUBMIT ASSESSMENT"
                            showModal={this.state.unsubmitAssessmentModal}
                            formData={[]}
                            selects={['']}
                            action={this.unsubmitAssessment.bind(this)}
                            toggleModal={this.unsubmitAssessmentToggle.bind(this)}
                            viewMessage={[{ text: `Are you sure you want to unsubmit these assessments?` }]}
                            triggerType={"YES"}
                        // noReset={'noReset'}
                        />
                    }

                    {
                        this.state.resetAssessmentModal &&
                        <ModalNew2
                            heading="RESET ASSESSMENT"
                            showModal={this.state.resetAssessmentModal}
                            formData={[]}
                            selects={['']}
                            action={this.resetAssessmentAction.bind(this)}
                            toggleModal={this.resetAssessmentToggle.bind(this)}
                            viewMessage={[{
                                text: `
            <div class="reset-warning text-center">
                <div class="warning-icon mb-3">
                    <i class="fas fa-exclamation-triangle fa-2x text-warning"></i>
                </div>
                <div class="warning-heading mb-2">
                    <strong>Warning: This action cannot be undone!</strong>
                </div>
                <div class="warning-text mb-3">
                    Resetting these assessments will:
                    <ul class="text-left mt-2 mb-3">
                        <li>Clear all participant responses</li>
                        <li>Remove all submitted data and results</li>
                        <li>Reset the assessment to its original state</li>
                    </ul>
                    Assessment settings and configurations will be retained.
                </div>
                <div class="confirmation-text">
                    Are you sure you want to reset these ${this.state.checkBoxData.length} assessment(s)?
                </div>
            </div>
        `
                            }]}
                            triggerType={"YES"}
                        />
                    }




                    {
                        this.state.toggleReportModal &&
                        <ModalNew2
                            heading={`${this.state.reportAction.toUpperCase()} REPORT`}
                            showModal={this.state.toggleReportModal}
                            formData={[]}
                            selects={['']}
                            action={this.toggleReport.bind(this)}
                            toggleModal={this.toggleReportToggle.bind(this)}
                            viewMessage={[{
                                text: `Are you sure you want to ${this.state.reportAction} these reports? 
                   This will ${this.state.reportAction} ${this.state.affectedReportCount} out of ${this.state.checkBoxData.length} selected report(s).`
                            }]}
                            triggerType={"YES"}
                        />
                    }




                    {
                        this.state.deleteReportModal &&
                        <ModalNew2
                            heading="DELETE ASSESSMENT"
                            showModal={this.state.deleteReportModal}
                            formData={[]}
                            selects={['']}
                            action={this.deleteReport.bind(this)}
                            toggleModal={this.deleteReportToggle.bind(this)}
                            viewMessage={[{ text: this.state.deleteReportText }]}
                            triggerType={"DELETE"}
                        />
                    }
                    {
                        this.state.setReportThemeModal &&
                        <ModalNew2
                            heading="SET REPORT THEME"
                            showModal={this.state.setReportThemeModal}
                            formData={reportThemeData}
                            selects={['report_theme_name']}
                            action={this.setReportTheme.bind(this)}
                            toggleModal={this.setReportThemeToggle.bind(this)}
                            viewMessage={[{ text: `You have selected ${this.state.checkBoxData.length} assessment.` }]}
                            triggerType={"SUBMIT"}
                            noReset={'noReset'}
                            selectKey={['id']}
                        />
                    }
                    {
                        this.state.setExpiryDateModal &&
                        <ModalNew2
                            heading="CHANGE EXPIRY DATE"
                            showModal={this.state.setExpiryDateModal}
                            formData={[
                                {
                                    key: 'expiry_list',
                                    type: 'date',
                                    value: this.state.expiryValue,
                                    valid: false,
                                    elementConfig: {
                                        name: 'expiry',
                                        label: 'SET EXPIRY DATE',
                                        placeholder: this.handleExpiryPlaceholder(this.state.expiryPlaceholderValidator),
                                        options: []
                                    },
                                    validation: {
                                        required: true,
                                        message: "is required"
                                    }
                                },

                            ]}
                            selects={['']}
                            action={this.setExpiryDate.bind(this)}
                            toggleModal={this.setExpiryDateToggle.bind(this)}
                            viewMessage={[{ text: `You have selected ${this.state.checkBoxData.length} assessment.` }]}
                            triggerType={"SUBMIT"}

                        />
                    }




                    {
                        this.state.setDevelopmentPlanModal &&
                        <ModalNew2
                            heading="SET DEVELOPMENT PLAN"
                            showModal={this.state.setDevelopmentPlanModal}
                            formData={setDevPlan}
                            selects={['dev_plan']}
                            hardCodeSelects={[
                                {
                                    id: 0,
                                    value: 'Integrated'
                                },
                                {
                                    id: 1,
                                    value: 'Stand-Alone'
                                }
                            ]}
                            action={this.setDevelopmentPlanAction.bind(this)}
                            toggleModal={this.setDevelopmentPlanToggle.bind(this)}
                            viewMessage={[{ text: `You have selected ${this.state.checkBoxData.length} assessment.` }]}
                            triggerType={"SUBMIT"}
                            noReset={'noReset'}
                            selectKey={['id']}
                            disableButton={this.state.vviSelected ? true : false}
                            vviSelected={this.state.vviSelected}
                        />
                    }

                    {
                        this.state.setCustomReportAccess &&
                        <ModalNew2
                            heading="SET CUSTOM REPORT ACCESS"
                            showModal={this.state.setCustomReportAccess}
                            formData={this.props.getCustomData}
                            checkboxKey={'results'}
                            selects={['']}
                            action={this.setCustomReportAction.bind(this)}
                            toggleModal={this.setCustomReportToggle.bind(this)}
                            viewMessage={[{ text: `You have selected ${this.state.checkBoxData.length} assessment.` }]}
                            triggerType={"SUBMIT"}
                            selectKey={['']}
                            disableButton={this.state.vviSelected ? true : false}
                            checkboxModal={{
                                heading: 'Relation Groups',
                                labelKey: 'relation_group_name',
                                selectAll: true,
                                deselectAll: true,
                                data: this.state.setCustomReportData,
                                vviSelected: this.state.vviSelected
                            }}
                            vviSelected={this.state.vviSelected}
                        />
                    }

                    {
                        this.state.removeCustomReportAccess &&
                        <ModalNew2
                            heading="REMOVE CUSTOM REPORT ACCESS"
                            showModal={this.state.removeCustomReportAccess}
                            formData={[]}
                            selects={['']}
                            action={this.removeCustomReportAction.bind(this)}
                            toggleModal={this.removeCustomReportToggle.bind(this)}
                            viewMessage={[{ text: 'Are you sure you want to remove custom report access to these assessments?' }]}
                            triggerType={"REMOVE"}
                            selectKey={['']}
                            checkboxModal={{
                                heading: `You have selected ${this.state.checkBoxData.length} assessment.`,
                                labelKey: 'relation_group_name',
                                selectAll: false,
                                deselectAll: false,
                            }}
                            disableButton={this.state.vviSelected ? true : false}
                            vviSelected={this.state.vviSelected}
                        />
                    }

                    {
                        this.state.tableModal &&
                        <ModalNew2
                            heading="User Report Access"
                            showModal={this.state.tableModal}
                            formData={[]}
                            selects={['']}
                            action={() => { this.modalOpener(false) }}
                            toggleModal={this.modalOpener.bind(this)}
                            viewMessage={[]}
                            triggerType={"OK"}
                            selectKey={['']}
                            checkboxModal={'a'}
                            onlyBackButton={true}
                            tableModalText={{
                                topHeading: 'The following reports are accessible to the user(s):',
                                topText: this.state.topTextModal,
                                bottomHeading: 'The following reports are not accessible to the user(s):',
                                bottomText: this.state.bottomTextModal
                            }}
                        />
                    }

                    {
                        this.state.addIndividualAnalytics &&
                        <ModalNew2
                            heading="Add Individual Analytics"
                            showModal={this.state.addIndividualAnalytics}
                            formData={[]}
                            action={(data) => this.addIndividualAnalyticsAction(data)}
                            toggleModal={this.addIndividualAnalyticsToggle.bind(this)}
                            viewMessage={[{ text: 'Add Individual Analytics?' }]}
                            triggerType={"OK"}
                        />
                    }
                    {
                        this.state.removeIndividualAnalytics &&
                        <ModalNew2
                            heading="Remove Individual Analytics"
                            showModal={this.state.removeIndividualAnalytics}
                            formData={[]}
                            action={(data) => this.removeIndividualAnalyticsAction(data)}
                            toggleModal={this.removeIndividualAnalyticsToggle.bind(this)}
                            viewMessage={[{ text: 'Remove Individual Analytics?' }]}
                            triggerType={"OK"}
                        />
                    }
                </div>

            </div>
        )
    }

    render() {
        if (true) {
            return (
                <div>
                    <NavBar />
                    {
                        this.state.idLoader ?
                            <div style={{ height: 'calc(100vh - 150px)' }} className="container d-flex justify-content-center">
                                <LoaderComp color={'black'} />
                            </div>
                            :
                            this.state.hasProperOrgId ?
                                this.renderManageOrganization()
                                :
                                <Page404 />

                    }
                    <Footer />
                </div>
            );
        } else {
            return (
                // add swal
                <h1>Something went wrong</h1>
            );
        }

    }

}

function mapStateToProps(state) {


    //org data
    const orgError = state.organisation.error;
    const orgLoading = state.organisation.loading;
    const orgList = (!orgError && !orgLoading) ? state.organisation.organisation.data.organisation_list : '';

    const { batch_list_error, batch_list_loading } = state.managaBatchList;
    const batchList = (!batch_list_error && !batch_list_loading) ? state.managaBatchList.batch_list.data.organisation_batch_list : '';

    //Mandate org
    const { add_org_mandate_loading, add_org_mandate_error } = state.addOrgMandate;
    const addOrgMandate = (!add_org_mandate_loading && !add_org_mandate_error) ? state.addOrgMandate.add_org_mandate.data.organisation_assessor_group_list : ''

    //unalloted List

    //Mandate org
    const { alloted_unalloted_list_loading, alloted_unalloted_list_error } = state.allotUnallotBatch;
    const allotedUnallotedList = (!alloted_unalloted_list_loading && !alloted_unalloted_list_error) ? state.allotUnallotBatch.alloted_unalloted_list.data.organisation_batch_assessment : ''

    //Manage participants

    const { participant_list_loading, participant_list_error } = state.participantsList;
    const participentList = (!participant_list_loading && !participant_list_error) ? state.participantsList.participant_list.data.participant_list : ''

    //Get Report Theme


    const { get_theme_report_loading, get_theme_report_error } = state.getReportTheme;
    const getThemeRep = (!get_theme_report_loading && !get_theme_report_error) ? state.getReportTheme.get_theme_report.data.theme_list : ''

    //get org and seller id

    const getOrgSellerId = state.setSellerAndOrgId

    //get custom report
    const { getCustomError, getCustomLoading, getCustomData } = state.getCustomReportState;

    // development plan list
    const { developmentPlanLoading } = state.developmentPlan;
    const developmentPlanError = state.developmentPlan.error;
    const developmentPlanResponse = (!developmentPlanLoading && !developmentPlanError) ? state.developmentPlan.data.data.results : [];
    const developmentPlanResponseCode = (!developmentPlanLoading) ? state.developmentPlan.data.status : '';

    return {
        batch_list_error,
        batchList,
        batch_list_loading,
        add_org_mandate_loading,
        add_org_mandate_error,
        addOrgMandate,
        alloted_unalloted_list_loading,
        alloted_unalloted_list_error,
        allotedUnallotedList,
        participant_list_loading,
        participant_list_error,
        participentList,
        get_theme_report_loading,
        get_theme_report_error,
        getThemeRep,
        getOrgSellerId,
        orgError,
        orgLoading,
        orgList,
        getCustomError,
        getCustomLoading,
        getCustomData,

        developmentPlanLoading,
        developmentPlanResponse,
        developmentPlanResponseCode,
    };
}

export default withRouter(connect(mapStateToProps)(CustomTag));


// WEBPACK FOOTER //
// ./src/_pages/Admin/Organisation/DetailLinks/CustomTags.js